import { Routes, UrlSegment } from '@angular/router';
import { PortalComponent } from './portal.component';

export function portalMatcher(segments: UrlSegment[]) {
  return segments.length > 0 && segments[0].path === 'portal' ? ({ consumed: segments }) : null;
}

export const portalRoutes: Routes = [
  {
    matcher: portalMatcher,
    component: PortalComponent,
    data: {
      allowAnonymous: true
    }
  }
];



// WEBPACK FOOTER //
// ./src/app/portal/portal.route.config.ts